import type { SiteSocialPlatform, UIFooterSocialLink } from '../types'
import { computed, useCoreConfig, type ComputedRef } from '#imports'

const platformDisplayName: Record<SiteSocialPlatform, string> = {
    facebook: 'Facebook',
    instagram: 'Instagram',
    youtube: 'YouTube',
    tiktok: 'TikTok',
    x: 'X',
    linkedin: 'LinkedIn',
}

/**
 * Resolves the brand's social media links from `site.socialLinks` in
 * `nuxt.config.ts` and shapes them for `<UIFooter :social>`.
 *
 * Aria-labels default to the platform display name (e.g. `"Facebook"`)
 * — screen readers announce the link href alongside, so the context is
 * clear. Override per link by setting `ariaLabel` in nuxt.config.
 *
 * @example
 * <UIFooter :social="useSiteSocialLinks().value" ... />
 */
export function useSiteSocialLinks(): ComputedRef<UIFooterSocialLink[]> {
    const { site } = useCoreConfig()

    return computed(() =>
        (site.socialLinks ?? []).map(link => ({
            platform: link.platform,
            url: link.url,
            ariaLabel: link.ariaLabel ?? platformDisplayName[link.platform],
        })),
    )
}
